import { Navigate, useLocation } from 'react-router-dom';
import type { PropsWithChildren } from 'react';
import { useAuthStore } from '@stores/auth';
import { usePermission } from '@hooks/usePermission';
import { FullPageSpinner } from '@components/ui';

export function ProtectedRoute({
  children,
  permission,
}: PropsWithChildren<{ permission?: string | string[] }>) {
  const { isAuthenticated, hydrated } = useAuthStore();
  const allowed = usePermission(permission);
  const location = useLocation();

  if (!hydrated) return <FullPageSpinner />;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!allowed) {
    // Redirect to the dedicated forbidden screen instead of `/dashboard`.
    // `/dashboard` is itself gated by `showDashboard`, so a user without that
    // permission would loop on a redirect chain. `/forbidden` is open to any
    // authenticated user and lands them on the always-visible Attendance hub.
    return (
      <Navigate
        to="/forbidden"
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  return <>{children}</>;
}
